module.exports = __webpack_public_path__ + "img/3_142.072470ec.png";